export const ROUTE_Login = 'Login';
export const ROUTE_Register = 'Register';
export const ROUTE_Dashboard = 'Dashboard';
export const ROUTE_CreateEditPH = 'CreateEditPH';
export const ROUTE_PHDetails = 'PHDetails';
export const ROUTE_CreateEditWarehouse = 'CreateEditWarehouse';
export const ROUTE_Challenges = 'Challenges';
export const ROUTE_WarehouseDetails = 'WarehouseDetails';
export const ROUTE_CreateEditAdmin = 'CreateEditAdmin';
export const ROUTE_AdminArticlesList = 'AdminArticlesList';
export const ROUTE_CreateEditArticleForm = 'CreateEditArticleForm';
export const ROUTE_AdminQuiz = 'AdminQuiz';
export const ROUTE_CreateEitQuiz = 'CreateEitQuiz';
export const ROUTE_QuizSummary = 'QuizSummary';
export const ROUTE_QuizAnswersSummary = 'QuizAnswersSummary';

export const isPHAllowedToSeeThisRoute = (currentRouteName: string):boolean => {
    return currentRouteName !== (
        ROUTE_CreateEditPH &&
        ROUTE_PHDetails &&
        ROUTE_CreateEditWarehouse &&
        ROUTE_Challenges &&
        ROUTE_WarehouseDetails &&
        ROUTE_WarehouseDetails &&
        ROUTE_CreateEditAdmin &&
        ROUTE_AdminArticlesList &&
        ROUTE_CreateEditArticleForm &&
        ROUTE_AdminQuiz &&
        ROUTE_CreateEitQuiz &&
        ROUTE_QuizAnswersSummary &&
        ROUTE_QuizSummary
    );
};

export const ROUTE_ADMIN_PREVIEW_QUERY = 'admin-preview';
